<template>
    <div>
        <div class="newOne">
            <div class="content">
                <h2>纸搬客创始人兼CEO李嘉轩谈受访专题</h2>
                <p class="p-1"><span class="span-1">纸搬客</span>2020年5月4日</p>
                <div class="details">
                    <img src="../../assets/img/newThree/1.png" alt="" class="img-2">
                    <p class="p-1">世界地球日当天，“首度财经频道”晚间新闻栏目，“世界地球日-环保专题”邀请纸搬客创始人兼CEO李嘉轩李总，为财经频道观众分享在互联网+模式下，纸搬客作为一家互联网环保公司做出的创新与发展。</p>
                    <img src="../../assets/img/newThree/2.png" alt="" class="img-2">
                    <p class="p-1 p-spe">以下为受访过程中，记者对于有关于纸搬客的回收模式、模式优势以及核心技术几个方面所提出的问题，及李总为大家做的分享：</p>
                    <img src="../../assets/img/newThree/3.png" alt="" class="img-2">
                   <p class="p-1 p-spe">首都财经频道的记者向李总提问：纸搬客主要是以什么方式将纸张进行收集又如何处理的？</p>
                   <p class="p-1">李总向大家分享：</p>
                   <p class="p-1 p-in p-spe">纸搬客是通过自主研发的智能废纸回收机通过与物业及居委会单位的合作入驻社区，居民用户通过手机APP或微信小程序扫码启动设备，将纸张放入桶内并通过设备的智能的粉碎、称重、返现的方式进行纸张回收</p>
                   <p class="p-1 p-in p-spe">同时纸搬客打通了与纸厂的合作，桶内纸张经过回收人员清运收集至纸搬客的打包中心进行打包，完成打包压缩后直接发往合作纸厂进行再造。</p>
                   <p class="p-1 p-in p-spe" style="margin-bottom: 0.15rem;">这种模式改变了原有通过垃圾回收小贩进行回收的方式，提高了回收效率的同时，也同样提高了可再造垃圾的质量，为纸厂等企业节省成本，为社区物业完善社区服务，为用户挖掘垃圾的真正价值、创造环保收益，这是纸搬客长久以来坚守的核心价值观</p>
                   <p class="p-1 p-spe">记者也就纸搬客的智能回收模式对比传统的回收方式都有哪些优势，以及互联网+环保的模式下纸搬客下一步的重心等问题邀请李总分享</p>
                   <p class="p-1 p-spe">李总向记者分享：</p>
                   <p class="p-1 p-in p-spe">纸搬客的核心优势在于通过智能设备进行回收的形式，改变改善了原有的回收模式，减少了中间环节，扩大了各方收益，用智能设备代替缺斤少两、无品牌化的小商小贩，但是又与之不存在直接竞争关系，相反，原来以收废品为生的小贩，现在都已经在纸搬客智能化的影响下成为了纸搬客的用户。</p>
                   <p class="p-1 p-in p-spe">目前纸搬客已经入驻北京多个社区，并且都有极具代表性的数据产出，获取了用户以及物业、居委会的一致好评，目前我们纸搬客也在加深自身的技术基础，在回收流程上再创新，另外为了更快更好的服务更多用户，我们纸搬客目前在面向全国推行、招募城市合伙人，只要是有一定资金、资源并且热衷环保的有志之士都可以加入我们的合伙队伍，跟纸搬客一同为垃圾分类、回收再造做出贡献。</p>
                  <strong>
                    <p class="p-2 p-in">
                        最后回归本质，纸搬客真正希望做到的是，能够通过纸搬客的模式、影响力去推动垃圾分类的快速实施及发展，我们更希望的是通过我们这一代的努力，能够对下一代产生积极影响，在未来五年十年，甚至更以后，当我们的下一代成为社会主要力量时，他们能够自觉的去进行垃圾分类，纸搬客能够在这个方向上先行并多走几步，我觉得无论是作为一家企业，还是作为一个有环保意识的公民，这都是非常有意义的。
                       </p>
                  </strong>
                </div>
            </div>
            <!-- footer -->
            <footer_s></footer_s>
        </div>
    </div>
</template>
<script>
    import footer_s from '../common/footer'
    export default {
        components: {
            footer_s
        },
    }
</script>
<style scoped>
    .newOne {
        width: 100%;
        min-height: 6.5rem;
        position: absolute;
        background-color: #fff;
        top: 0rem;
        left: 0;
        z-index: 100;
    }
    .content{
        width: 60%;
        min-height: 6.5rem;
        margin: 0 auto;
        padding: 0 5%;
    }
    .content h2 {
        font-size: 0.13rem;
        font-family: PingFang SC;
        font-weight: bold;
        color: rgba(14, 14, 14, 1);
        line-height: 0.2rem;
        margin-top: 0.1rem;
    }
    .span-1{
        font-size: 0.06rem;
        margin-right: 0.03rem;
        color: #576b95;
    }
    .p-1 {
        font-size: 0.05rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: #444;
        line-height: 0.09rem;
    }
    .details{
        width: 100%;
    }
    .p-spe{
        margin-bottom: 0.08rem;
    }
    .p-in{
        text-indent: 2em;
    }
    .img-2{
        width: 100%;
        height: 100%;
        margin-top: 0.07rem;
    }
    .p-2{
        font-size: 0.05rem;
        font-family: DengXian;
        caret-color: rgb(0, 0, 0);
        color: rgb(0, 0, 0);
        white-space: normal;
        line-height: 0.08rem;
        margin-bottom: 0.15rem;
    }
</style>


// WEBPACK FOOTER //
// src/views/newChild/newThree.vue